module.exports = ".wrapper {\n  width: 81.63%;\n  margin: auto;\n  margin-top: 10px;\n  margin-bottom: 20px; }\n\n.cover {\n  margin-bottom: 10px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/channel/channel.component.scss
// module id = ./src/app/channel/channel.component.scss
// module chunks = main